import React, { useState } from 'react';
import { TextField, Button, Box, Typography, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Step1Account = ({ formData, handleChange, nextStep }) => {
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleNext = () => {
    if (!formData.email || !formData.password) {
      setError('Email and Password are required.');
      return;
    }
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    // Basic password validation (e.g., at least 6 characters)
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }
    setError('');
    nextStep();
  };

  return (
    <Box component="form" sx={{ mt: 3 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email Address"
        name="email"
        autoComplete="email"
        autoFocus
        value={formData.email || ''}
        onChange={handleChange}
        error={!!(error && error.includes('Email'))}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label="Password"
        type={showPassword ? "text" : "password"}
        id="password"
        autoComplete="current-password"
        value={formData.password || ''}
        onChange={handleChange}
        error={!!(error && error.includes('Password'))}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
      <Button
        type="button"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        onClick={handleNext}
      >
        Next
      </Button>
    </Box>
  );
};

export default Step1Account;
